const content_list = [
    {
        name: "About",
        description: "Introduction to a few spaces",
        created_date: new Date(2020, 10, 13),
        path: "about"

    },
    {
        name: "Optimisation",
        folder: true,
        path: 'optim',
        items: []
    },
    {
        name: "Machine Learning",
        folder: true,
        path: 'ml',
        items: [
            {
                name: "Rademacher Complexity",
                description: "Rademacher complexity",
                created_date: new Date(2020, 10, 20),
                path: "rademacher-complexity"
            }
        ]
    },
    {
        name: "Linear Algebra",
        folder: true,
        path: 'la',
        items: [
            {
                name: "Metric Spaces",
                description: "Introduction to a few spaces",
                created_date: "",
                path: "metric-spaces"
            }
        ]
    },
    {
        name: "Differential Geometry",
        path: 'diff-geom',
        folder: true,
        items: []
    },
    // {
    //     name: "Functional Analysis",
    //     folder: true,
    //     items: []
    // },
    // {
    //     name: "Algebraic Geometry",
    //     folder: true,
    //     items: []
    // },
    // {
    //     name: "Differential Topology",
    //     folder: true,
    //     items: []
    // }
]

export default content_list;
